const baseURL = 'https://comas.txstyperu.com/';

export default baseURL;
